export const DEFAULT_DATE_TYPE_FORMAT = "yyyy-MM-dd";
export const DateTypeFormats = [
  "yyyy-MM-dd",
  "MM/dd/yyyy",
  "MM-dd-yyyy",
] as const;
